var _desc, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 201,
    height: 40,
    viewBox: "0 0 201 40",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "RelianceHMO-svglogo-03") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created using Figma")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Canvas",
    transform: "translate(-3310 965)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "RelianceHMO-svglogo-03"
  }, /*#__PURE__*/React.createElement("g", {
    id: "option 1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "SVG LOGO"
  }, /*#__PURE__*/React.createElement("g", {
    id: "logo"
  }, /*#__PURE__*/React.createElement("g", {
    id: "TRUST"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path0_fill",
    transform: "translate(3310 -949.12)",
    fill: "#094063"
  })), /*#__PURE__*/React.createElement("g", {
    id: "HEALTH"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path1_fill",
    transform: "translate(3325.87 -965)",
    fill: "#89CBF0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "INTERSECT"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path2_fill",
    transform: "translate(3325.87 -948.999)",
    fill: "#5299D3"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "name"
  }, /*#__PURE__*/React.createElement("g", {
    id: "R"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path3_fill",
    transform: "translate(3362.1 -953.361)",
    fill: "#094063"
  })), /*#__PURE__*/React.createElement("g", {
    id: "e"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path4_fill",
    transform: "translate(3375.94 -947.721)",
    fill: "#094063"
  })), /*#__PURE__*/React.createElement("g", {
    id: "l"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path5_fill",
    transform: "translate(3390.34 -954.573)",
    fill: "#094063"
  })), /*#__PURE__*/React.createElement("g", {
    id: "i"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path6_fill",
    transform: "translate(3395.88 -953.361)",
    fill: "#094063"
  })), /*#__PURE__*/React.createElement("g", {
    id: "a"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path7_fill",
    transform: "translate(3401.22 -947.765)",
    fill: "#094063"
  })), /*#__PURE__*/React.createElement("g", {
    id: "n"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path8_fill",
    transform: "translate(3414.45 -947.667)",
    fill: "#094063"
  })), /*#__PURE__*/React.createElement("g", {
    id: "c"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path9_fill",
    transform: "translate(3427.54 -947.789)",
    fill: "#094063"
  })), /*#__PURE__*/React.createElement("g", {
    id: "e 1"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path10_fill",
    transform: "translate(3439.31 -947.721)",
    fill: "#094063"
  })), /*#__PURE__*/React.createElement("g", {
    id: "H"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path11_fill",
    transform: "translate(3453.83 -953.361)",
    fill: "#89CBF0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "M"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path12_fill",
    transform: "translate(3471.52 -953.361)",
    fill: "#89CBF0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "O"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path13_fill",
    transform: "translate(3492.61 -953.871)",
    fill: "#89CBF0"
  })))))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "path0_fill",
    d: "M 15.9949 3.75647L 15.9949 4.62252e-07L 3.99872 4.62252e-07C 2.90816 4.62252e-07 1.93878 0.484707 1.21173 1.21177C 0.484694 1.93883 0 3.15059 0 4.36236C 0.121173 6.42236 1.93878 8.11883 4.1199 8.11883L 15.9949 8.11883L 15.9949 20.1153C 15.9949 22.4177 18.0548 24.2353 20.236 24.1141C 22.2959 23.993 23.9923 22.1753 23.9923 19.9941L 23.9923 8.11883L 20.236 8.11883C 17.8125 7.99765 15.9949 6.18001 15.9949 3.75647Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1_fill",
    d: "M 23.9923 19.6363C 23.8712 17.5763 22.0536 15.8799 19.8724 15.8799L 7.99745 15.8799L 7.99745 4.00455C 7.99745 1.7022 5.9375 -0.115451 3.75638 0.00572533C 1.69643 0.126902 4.6224e-07 1.94455 4.6224e-07 4.12573L 4.6224e-07 16.001L 3.75638 16.001C 6.05867 16.001 7.99745 17.9399 7.99745 20.2422L 7.99745 23.9987L 19.9936 23.9987C 21.0842 23.9987 22.0536 23.514 22.7806 22.7869C 23.6288 21.9387 23.9923 20.8481 23.9923 19.6363Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2_fill",
    d: "M 3.75638 -2.31126e-07L 4.6224e-07 -2.31126e-07L 4.6224e-07 3.75647C 4.6224e-07 6.05883 1.93878 7.99766 4.24107 7.99766L 7.99745 7.99766L 7.99745 4.24118C 7.99745 1.81765 6.17985 -2.31126e-07 3.75638 -2.31126e-07Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3_fill",
    d: "M 0 4.62252e-07L 4.36224 4.62252e-07C 6.78571 4.62252e-07 9.93622 0.242353 10.9056 2.90824C 11.9962 6.05883 10.0574 8.84589 6.90689 9.3306L 11.875 17.3283L 9.33035 17.3283L 4.60459 9.57295L 1.93877 9.57295L 1.93877 17.3283L 0 17.3283L 0 4.62252e-07ZM 2.05995 7.63412L 3.87755 7.63412C 5.69515 7.63412 8.48214 7.7553 8.96684 5.57412C 9.5727 2.78706 7.02806 1.93883 4.84694 1.93883L 1.93877 1.93883L 1.93877 7.63412L 2.05995 7.63412Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path4_fill",
    d: "M 10.8846 9.6281C 8.94586 12.0516 5.18948 12.7787 2.52367 11.0822C 0.221375 9.50692 -0.505665 6.35633 0.342549 3.81162C 1.31194 1.14574 3.97775 -0.308378 6.76474 0.0551512C 9.79407 0.539857 11.2482 3.08456 11.2482 5.9928L 11.2482 6.59868L 2.03897 6.59868C 2.28132 10.4763 7.12826 11.3246 9.43055 8.53751L 10.8846 9.6281ZM 9.30938 4.90221C 9.1882 0.539856 2.64484 0.782209 2.16015 4.90221L 9.30938 4.90221Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path5_fill",
    d: "M 3.69792e-06 4.62252e-07L 1.93878 4.62252e-07L 1.93878 18.4188L 3.69792e-06 18.4188L 3.69792e-06 4.62252e-07Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path6_fill",
    d: "M 1.3632 4.62252e-07C 3.1808 4.62252e-07 3.1808 2.78706 1.3632 2.78706C -0.4544 2.78706 -0.4544 4.62252e-07 1.3632 4.62252e-07ZM 0.39381 5.81647L 2.33259 5.81647L 2.33259 17.2071L 0.39381 17.2071L 0.39381 5.81647Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path7_fill",
    d: "M 0.510259 1.79559C 2.20669 0.0991205 5.23603 -0.506762 7.41715 0.462651C 9.23476 1.18971 9.84062 3.00736 9.84062 4.94618L 9.84062 9.91442C 9.84062 10.5203 9.96179 11.2474 9.96179 11.8532L 8.14419 11.8532C 8.02302 11.3685 8.02302 10.6415 8.02302 10.1568C 6.08425 13.3074 -0.459121 12.7015 0.0255727 8.33913C 0.389093 4.94618 4.63016 4.82501 7.1748 4.82501L 7.90185 4.82501L 7.90185 4.46148C 7.90185 1.18971 3.41842 1.55324 1.72199 3.24971L 0.510259 1.79559ZM 6.08425 6.15795C 4.99369 6.15795 3.41843 6.27913 2.57021 7.12736C 1.84317 7.85442 1.96434 9.30854 2.81256 9.91442C 5.11485 11.6109 7.90185 9.30854 8.02302 6.88501L 8.02302 6.15795L 6.08425 6.15795Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path8_fill",
    d: "M 0.121177 2.9088C 0.121177 1.81822 -3.69792e-06 0.969979 -3.69792e-06 0.24292L 1.8176 0.24292C 1.8176 0.848803 1.8176 1.45469 1.8176 2.18174C 2.78699 0.121744 5.45281 -0.362962 7.39158 0.24292C 9.20919 0.969979 9.93622 2.78763 9.93622 4.60528L 9.93622 11.6335L 8.23979 11.6335L 8.23979 4.72645C 8.23979 2.66645 6.90688 1.21233 4.72576 1.69704C 2.66581 2.18174 2.05995 4.12057 2.05995 6.05939L 2.05995 11.6335L 0.121177 11.6335L 0.121177 2.9088Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path9_fill",
    d: "M 8.72448 3.15192C 7.63392 1.81898 5.69515 1.33427 3.99873 2.18251C 2.66582 2.90957 1.93877 4.36369 1.93877 5.81781C 1.93877 7.3931 2.54465 8.9684 3.99873 9.81664C 5.57398 10.6649 7.63392 10.3013 8.72448 8.84722L 10.1786 10.1802C 8.48214 12.119 5.33163 12.4825 3.15051 11.3919C 1.09056 10.4225 0 8.24134 0 6.06016C 0 3.75781 1.09056 1.6978 3.15051 0.607212C 5.4528 -0.483378 8.48214 -0.119848 10.2997 1.81898L 8.72448 3.15192Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path10_fill",
    d: "M 10.8846 9.6281C 8.94585 12.0516 5.18949 12.7787 2.52367 11.0822C 0.221378 9.50692 -0.505666 6.35633 0.342548 3.81162C 1.31194 1.14574 3.97775 -0.308378 6.76474 0.0551512C 9.79408 0.539857 11.2482 3.08456 11.2482 5.9928L 11.2482 6.59868L 2.03898 6.59868C 2.28132 10.4763 7.12826 11.3246 9.43055 8.53751L 10.8846 9.6281ZM 9.18821 4.90221C 9.06704 0.539856 2.52367 0.782209 2.03898 4.90221L 9.18821 4.90221Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path11_fill",
    d: "M -3.69792e-06 4.62252e-07L 2.05995 4.62252e-07L 2.05995 7.2706L 11.2691 7.2706L 11.2691 4.62252e-07L 13.3291 4.62252e-07L 13.3291 17.3283L 11.2691 17.3283L 11.2691 9.3306L 2.05995 9.3306L 2.05995 17.3283L -3.69792e-06 17.3283L -3.69792e-06 4.62252e-07Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path12_fill",
    d: "M 3.69792e-06 4.62252e-07L 3.02934 4.62252e-07L 8.84566 13.5718L 14.7832 4.62252e-07L 17.8125 4.62252e-07L 17.8125 17.3283L 15.7525 17.3283L 15.7525 2.78706L 9.57269 17.3283L 8.36096 17.3283L 2.18113 2.78706L 2.18113 17.3283L 0.121166 17.3283L 0.121166 4.62252e-07L 3.69792e-06 4.62252e-07Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path13_fill",
    d: "M -3.69792e-06 9.11376C -3.69792e-06 5.35728 2.18112 1.84316 5.81632 0.510221C 9.45153 -0.701544 13.6926 0.267868 16.1161 3.17611C 18.4184 6.08434 18.6607 10.4467 16.8431 13.7185C 14.9043 17.1114 10.9056 18.5655 7.14924 17.9596C 2.90817 17.3538 -3.69792e-06 13.4761 -3.69792e-06 9.11376ZM 15.8737 9.11376C 15.8737 6.20552 14.2985 3.41846 11.5115 2.32787C 8.72448 1.23728 5.4528 2.08552 3.6352 4.38787C -0.242351 9.35611 3.75637 17.2326 10.2997 16.142C 13.6926 15.6573 15.8737 12.5067 15.8737 9.11376Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.de34d78138066e7eedd5f76ab08bbe1f.svg";
export { ForwardRef as ReactComponent };